import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class TensionAccessoriesRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} attr="Produktgruppenbild"/></td>
            <AttributeCell product={product} attr="Produktgruppenbeschreibung_kurz"/>
            <MiscCell product={product}/>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={2} product={product} attr="name">
                {product.parent ? product.parent.name : ''} {product.name}
            </HeadlineCell>
            <WatchlistCell product={product}/>
        </>;
    }
}
